import { captureAnalyticsException } from "../posthog";

const triggeredMarkers = new Set<string>();

const FrontendSentryTestTrigger = () => {
  const params = new URLSearchParams(window.location.search);
  const marker = params.get("sentry_test");
  const isEnabled =
    window.__BITSENTRY_RUNTIME_CONFIG__?.enableSentryTestTrigger ??
    import.meta.env.VITE_ENABLE_SENTRY_TEST_TRIGGER === "true";

  if (
    isEnabled &&
    window.location.pathname === "/sentry-test" &&
    marker !== null &&
    /^[A-Za-z0-9._:-]{1,80}$/.test(marker) &&
    !triggeredMarkers.has(marker)
  ) {
    triggeredMarkers.add(marker);
    const error = new Error(`Frontend Sentry test error: ${marker}`);
    captureAnalyticsException(error);
    throw error;
  }

  return null;
};

export default FrontendSentryTestTrigger;
